export default __webpack_public_path__ + "static/media/customer1.5e0489f3.svg";